// Shared by the catalog, seed and fictional website. No account or delivery identity.
const step = (id, type, prompt, field, options = [], config = {}, label) => ({
  id, step_type: type, step_prompts: [prompt], step_columns: [field],
  step_options: options.map(text => ({label:text,goto:''})), step_description:'', step_config:config,
  ...(label ? {step_answer:{version:1,label,label_mode:'custom'}} : {}),
});

export const HELP_CONTACT_TEMPLATE = {
  id:'help_contact_hub', name:'Help & contact hub', category:'support', icon:'help',
  description:'Answer common questions before collecting a support request. Visitors can read answers without sharing contact details.',
  tags:['Quick answers','Support requests'], featured:false,
  marketing_excluded:true,
  appearance:{
    title:'Your help desk', subtitle:'Answers and a way forward',
    display_mode:'chat', trigger:'none', presentation_style:'assistant',
    launcher_style:'invitation', launcher_label:'Need a hand?', launcher_hint:'Find an answer or send a request', visitor_controls:true,
    theme_mode:'light', theme_color:'#315b52', font:'Arial, Helvetica, sans-serif',
    visual_style:'paper', message_style:'soft', motion_style:'fade',
    home:true, actions:[{type:'chat',label:'Support',value:''}],
    welcome_experience:{layout:'help_hub',heading:'A little help. A clear next step.',intro:'Find a quick answer or tell us what you need.',
      primary_action:'chat',primary_label:'Send a support request',answers:[
        {question:'What should I include in my request?',answer:'Tell us what you need help with, what happened, and what you expected. Include any useful context, but leave out passwords, payment details and security codes.'},
        {question:'How will you reply?',answer:'We ask for your name and email when you send a request so our team can follow up. You can read these answers without sharing your contact details.'},
        {question:'Does sending a request change my account?',answer:'No. Sending a request asks our team to review it. It does not change your account, cancel a service or issue a refund.'},
      ]},
    summary:true,summary_heading:'Your support request',summary_confirm_label:'Send support request',
    success_title:'Request sent',success_text:'Your request has been received. Our team can follow up using the email you shared.',
  },
  steps:[
    step('topic','single_select','What do you need help with?','product_interest',['Account access','Billing question','Something isn’t working','Something else'],{},'Support topic'),
    step('details','text','Tell us what you need help with.','description',[],{},'Request details'),
    step('name','text','Your name','name',[],{group_heading:'Where can we reply?'}),
    step('email','email','Email address','email',[],{group_with_previous:true}),
  ],
};
